function FinishScreen({ points, maxPossiblePoints, highscore, dispatch, status }) {

    const percentage = (points / maxPossiblePoints) * 100;

    let emoji;

    if (percentage >= 0) emoji = '💎';
    if (percentage >= 20) emoji = '👀';
    if (percentage >= 40) emoji = '🅾';
    if (percentage >= 60) emoji = '🥉';
    if (percentage >= 80) emoji = '🥈';
    if (percentage === 100) emoji = '🥇';

    const shareText = `🎓 I scored ${points} out of ${maxPossiblePoints} (${Math.ceil(percentage)}%) on the Frack to School Quiz! Test your knowledge at https://ecocarto.com/quizzes/schools/`;

    return (
        <div className="finish-screen">
            <p className="result">
                <span>{emoji}</span> You scored <strong>{points}</strong> out of {maxPossiblePoints} ({Math.ceil(percentage)}%)
            </p>

            <div className="share">
                <h4>Share Your Score</h4>
                <textarea
                    readOnly
                    value={shareText}
                    onFocus={(e) => e.target.select()}
                    rows="3"
                    className="share-textarea"
                />

                <p className="moreinfo">
                    Visit the EcoCarto website to learn more about{' '}
                    <a href="https://ecocarto.com/category/schools" target="_blank" rel="noreferrer">
                        oil & gas near schools
                    </a>
                    {' '}and see{' '}
                    <a href="https://ecocarto.com/2025/10/quiz-answers-frack-to-school/" target="_blank" rel="noreferrer">
                        how we calculated these statistics
                    </a>.
                </p>
            </div>

            <div className="action-buttons">
                <button className="btn btn-ui btn-small" onClick={() => dispatch({ type: 'restart' })}>
                    Take The Quiz Again
                </button>
                <button
                    className="btn btn-ui btn-small btn-coffee"
                    onClick={() => window.open("https://www.buymeacoffee.com/ecocarto", "_blank", "noopener,noreferrer")}
                >
                    ☕ Buy Me a Coffee
                </button>
            </div>
        </div>
    );
}

export default FinishScreen;